module.exports = __webpack_public_path__ + "media/icons/standard-chevron-1acc8738.svg";